const GA_COOKIE_NAME = '_ga';

const parseCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${name}=([^;]*)`),
  );
  return match?.[1];
};

/**
 * Extracts GA4 client ID from the `_ga` cookie.
 * Cookie format: `GA1.1.1234567890.1234567890`
 * Client ID: `1234567890.1234567890` (last two dot-separated segments)
 *
 * Returns empty string for mobile (no document.cookie) or when cookie is absent.
 */
export const getGA4ClientId = (): string => {
  const gaCookie = parseCookie(GA_COOKIE_NAME);
  if (!gaCookie) return '';

  const parts = gaCookie.split('.');
  if (parts.length < 4) return '';

  return `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
};
